import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress } from '../../../../Fct/generics';
import { getRadiantV2Tokens } from '../../../../Fct/plugins/allowanceRequiredProtocols';
import { PROTOCOL_DATA_PROVIDER_ADDRESSES } from '../constants';
export var GetReserveTokensAddresses = createPlugin({
    protocol: 'RADIANTV2',
    type: 'GETTER',
    method: 'getReserveTokensAddresses',
    supportedContracts: PROTOCOL_DATA_PROVIDER_ADDRESSES,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({ destination: 'radiant_lending_pool_v2' }),
                methodParams: {
                    asset: new FctAddress({ destination: 'erc20', options: getRadiantV2Tokens({ chainId: chainId }) }),
                },
            },
            output: {
                aTokenAddress: new FctAddress({ innerIndex: 0 }),
                stableDebtTokenAddress: new FctAddress({ innerIndex: 1 }),
                variableDebtTokenAddress: new FctAddress({ innerIndex: 2 }),
            },
        });
    },
});
